export const SET_COLUMN_SELECTOR = "SET_COLUMN_SELECTOR";
export const SET_ORIGINAL_COLUMN_SELECTOR = "SET_ORIGINAL_COLUMN_SELECTOR"

/**
 * Sets general loading set content
 */
export const setColumnSelector = contentObject => {
    return (dispatch) => {
      dispatch({
        type: SET_COLUMN_SELECTOR,
        payload: contentObject,
      });
    };
  }

  export const setOriginalColumnSelector = contentObject => {
    return (dispatch) => {
      dispatch({
        type: SET_ORIGINAL_COLUMN_SELECTOR,
        payload: contentObject,
      });
    };
  }